import { useCallback, useState } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

const DISMISS_KEY = (pageId: string) => `cfind-polish-banner-dismissed-${pageId}`;

/**
 * Returns the dismissal state and a dismiss callback for the ImportedPagePolishBanner.
 * Dismissal is persisted per-page in localStorage so the banner doesn't re-appear
 * after the user has dismissed it.
 */
export const usePolishBannerDismissal = (
	pageId: string,
): { dismissed: boolean; dismiss: () => void } => {
	const [dismissed, setDismissed] = useState<boolean>(() => {
		return confluenceLocalStorageInstance?.getItemAsBoolean(DISMISS_KEY(pageId)) ?? false;
	});

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const dismiss = useCallback(
		(fireAnalytic: boolean = true) => {
			if (fireAnalytic) {
				createAnalyticsEvent({
					type: 'sendUIEvent',
					data: {
						action: 'clicked',
						actionSubject: 'button',
						source: 'cfind-5926-upload-in-onboarding-use-polish-banner-dismiss-button',
					},
				}).fire();
			}
			confluenceLocalStorageInstance?.setItem(DISMISS_KEY(pageId), true);
			setDismissed(true);
		},
		[pageId, createAnalyticsEvent],
	);

	return { dismissed, dismiss };
};
